export default "__VITE_ASSET__b97eb5f0__"